import React from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import ModalDialog from './ModalDialog';
import Button from '../Buttons/Button';

export default function Confirmation(props) {
  const { content, no, noButton, title, yes, yesButton,
          toggleDialog, open, fullWidth } = props;

  return (
    <ModalDialog
      dialogStatus={open}
      toggleDialog={toggleDialog}
      title={title}
      fullWidth={fullWidth}
      buttonStack={(
        <>
          <Button variant='closeDialog' onClick={no} data-cy="confirmNo">{noButton}</Button>
          <Button variant='save' onClick={yes} data-cy="confirmYes">{yesButton}</Button>
        </>
      )}
    >
      <DialogContentText id="alert-dialog-description">
        {content}
      </DialogContentText>
    </ModalDialog>
  );
}
